<template>
  <div class="wrapper" v-if="config">
    <sidebar-menu :linkTo="{name:'home'}">
      <ul>
        <router-link tag="li" :to="{name:'home'}" exact>
          <a><i class="fad fa-home"/> Home</a>
        </router-link>
        <li v-if="isTabletOrBigger">
          <a href="#dropdown-teamlead" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
            <i
                class="fas fa-user-hard-hat"/> Teamlead</a>
          <ul class="collapse" id="dropdown-teamlead">
            <router-link v-if="this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7" tag="li"
                         :to="{name: dockSuggestionRoute}" exact>
              <a><i class="far fa-map-signs"/> {{ $t('shopfloor.menu.teamlead.dockSuggestions') }}</a>
            </router-link>
            <router-link
                v-if="!getAppStatus.disableScanners && (this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7)"
                tag="li"
                :to="{name: orderHandlingRoute}" exact>
              <a><i class="far fa-file-alt"/> {{ $t('shopfloor.menu.teamlead.orderHandling') }}</a>
            </router-link>
            <router-link
                v-if="!getAppStatus.disableScanners && (this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 9)"
                tag="li"
                :to="{name: cargoHandlingRoute}" exact>
              <a><i class="far fa-file-alt"/> {{ $t('shopfloor.menu.teamlead.cargoHandling') }}</a>
            </router-link>
            <router-link
                v-if="!getAppStatus.disableScanners && (this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7)"
                tag="li"
                :to="{name: $route.path.indexOf('/unloading') ? 'teamlead-deviations-loading' : 'teamlead-deviations-unloading'}"
                exact>
              <a><i class="far fa-exclamation-circle"/> {{ $t('shopfloor.menu.teamlead.deviations') }}</a>
            </router-link>
            <!--                        <router-link tag="li" :to="{name:'teamlead-unloading-sender-overview'}" exact>-->
            <!--                            <a><i class="fas fa-truck"/>{{$t('shopfloor.menu.teamlead.senderOverview')}}</a>-->
            <!--                        </router-link>-->
            <router-link v-if="!getAppStatus.disableScanners" tag="li" :to="{name:'teamlead-cargo-loading-overview'}"
                         exact>
              <a><i class="fad fa-truck-loading"/> {{ $t('shopfloor.menu.teamlead.cargoOverview') }}</a>
            </router-link>

            <router-link v-if="!getAppStatus.disableScanners" tag="li" v-show="config.unloading.cargo"
                         :to="{name:'teamlead-cargos-unloading'}"
                         exact>
              <a><i class="fad fa-truck-ramp"/>
                {{ $t('shopfloor.menu.teamlead.cargoUnloadingOverview') }}</a>
            </router-link>
          </ul>
        </li>
        <router-link
            v-if="(this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7) && !getAppStatus.disableScanners"
            tag="li"
            :to="{name: 'loodsopname'}" exact>
          <a><i class="far fa-clipboard-check"/> {{ $t('shopfloor.menu.loodsopname') }}</a>
        </router-link>
        <router-link tag="li" :to="{name:'stock-location-change'}" exact v-if="!getAppStatus.disableScanners">
          <a><i class="fal fa-warehouse"/> {{ $t('shopfloor.menu.stockChange') }}</a>
        </router-link>
        <router-link v-if="this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7" tag="li"
                     :to="{name: 'ScanTraceableProduct'}" exact>
          <a><i class="far fa-map-signs"/> {{ $t('shopfloor.menu.scanTraceableProduct') }}</a>
        </router-link>
        <router-link v-if="(this.getMeBasic.companyId === 1 || this.getMeBasic.companyId === 7) && getPageVisibility('cycle-count')" tag="li"
                     :to="{name:'cycle-count'}" exact>
          <a><i class="fal fa-abacus"/> {{ $t('shopfloor.menu.cycleCount') }}</a>
        </router-link>
      </ul>

      <div id="loggedIn">
        <p><i class="fas fa-info-circle"></i> V {{ version }} </p>
        <p><i class="fad fa-user"/>{{ getUserName }} <i @click="logout()" style="font-size:20px"
                                                        class="fad fa-sign-out-alt"/></p>
      </div>

    </sidebar-menu>

    <topbar>
      <template slot="left">
        <a href="javascript:;" id="sidebarCollapse" @click="collapsed = !collapsed">
          <i class="fal" :class="[collapsed ? 'fa-bars' : 'fa-align-left']"/>
        </a>
        <router-link v-if="!getAppStatus.disableScanners" class="topbar-link-truck" tag="a" :to="{name:'loading'}">
          <i class="fas fa-truck-loading"/> {{ this.$t('shopfloor.loading') }}
        </router-link>
        <router-link v-if="!getAppStatus.disableScanners" class="topbar-link-truck" tag="a" :to="{name:'unloaded'}">
          <i class="fas fa-truck-ramp"/> {{ this.$t('shopfloor.unloading') }}
        </router-link>
      </template>
    </topbar>

    <div id="m-content">
      <router-view/>
    </div>

    <loading-screen/>
    <!--    <vue-progress-bar/>-->
  </div>


  <!--    <vue-progress-bar/>-->


</template>


<script>


import {mapGetters} from 'vuex';

import {LoadingScreen, SidebarMenu, Topbar} from 'motivate-framework-components';
import Vue from 'vue';
import initLogRocket from './init/initLogRocket';
import closeCargo from "@/mixins/closeCargo";
import store from "@/store";
import {openCargo} from "@/mixins/openCargo";

export default {
  name: 'App',
  components: {
    SidebarMenu,
    LoadingScreen,
    Topbar
  },
  mixins: [openCargo],
  data() {
    return {
      version: require('./../package.json').version,
      collapsed: false,
      config: null,
      orderHandlingRoute: 'teamlead-order-handling-loading',
      cargoHandlingRoute: 'teamlead-cargo-handling-loading',
      dockSuggestionRoute: 'teamlead-dock-suggestions-loading'
    };
  },
  firestore() {
    return {
      config: this.$FB.collection('config').doc(this.getMeBasic.companyId.toString())
    };
  },
  methods: {
    notAllowedToScan(e) {
      this.$swal.fire({
        html: this.$root.$t('shopfloor.delay', [(e / 1000)]),
        showConfirmButton: false,
        timer: e
      });
    },
    async logout() {
      await closeCargo();
      return this.$auth.logout();
    },
    getOrderHandlingRoute() {
      let noLocalStorageOrderHandling = this.$route.path.indexOf('/unloading') > -1 ? 'teamlead-order-handling-unloading' : 'teamlead-order-handling-loading'
      let noLocalStorageDockSuggestions = this.$route.path.indexOf('/unloading') > -1 ? 'teamlead-dock-suggestions-unloading' : 'teamlead-dock-suggestions-loading'

      let localOrderHandling = localStorage.getItem('orderhandling-view') ? (localStorage.getItem('orderhandling-view') === 'loading' ? 'teamlead-order-handling-loading' : 'teamlead-order-handling-unloading') : null
      // Use same local storage so that orderhandling and dock suggestions are in sync
      let localDockSuggestions = localStorage.getItem('orderhandling-view') ? (localStorage.getItem('orderhandling-view') === 'loading' ? 'teamlead-dock-suggestions-loading' : 'teamlead-dock-suggestions-unloading') : null

      this.orderHandlingRoute = localOrderHandling ? localOrderHandling : noLocalStorageOrderHandling;
      this.dockSuggestionRoute = localDockSuggestions ? localDockSuggestions : noLocalStorageDockSuggestions;
    }
  },
  computed: {
    ...mapGetters('users', [
      'getMe',
      'getMeBasic',
      'getUserName'
    ]),
    ...mapGetters('companies', [
      'getCompanies'
    ]),
    ...mapGetters('userData', [
      'getMyFunction', 'getPageVisibility'
    ]),
    ...mapGetters([
      'getLoadingTypes'
    ]),
    ...mapGetters('appstatus', [
      'getAppStatus'
    ]),
    loggedInUser() {
      let user = this.$store.state.users.me;
      return user.firstname + ' ' + user.lastname;
    },
    isTabletOrBigger() {
      return window.screen.width > 720;
    }
  },
  watch: {
    config() {
      Vue.prototype.$APP_CONFIG = this.config;
    },
    getAppStatus: {
      handler: function (newStatus) {
        if (newStatus.disableScanners && this.$route.name !== 'cycle-count') {
          this.$router.push({name: 'home'});
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    localStorage.removeItem('unloading-unloaded-overview')
    if (this.$APP_CONFIG.scanner.type !== 'bluetooth') {
      this.$BluetoothScan.detachFrom(document);
    }
    this.$barcodeScanner.barCodeEventBus.$off('scanDelayed', this.notAllowedToScan);
  },
  created() {
    let user = Vue.prototype.$auth.getUser();

    this.$store.dispatch('initDataForPage', [{module: 'userData', where: ['id', '==', this.getMeBasic.userId]}]);

    initLogRocket(user);
    if (this.$APP_CONFIG.scanner.type == 'bluetooth') {
      this.$BluetoothScan.attachTo(document, {
        // *TURN THIS ON WHEN SCANNERS ARE USED THAT SUPPORT THIS*
        // reactToPaste: true, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
        // sCode is barcode scanned, iQry is the amount of barcodes at once (default is 1, so sends barcode XXX and qty 1)
        onScan: (sCode, iQty) => {
          return this.$barcodeScanner.barCodeEventBus.$emit('barcodeScanned', sCode);
        },
        onScanError: (error) => {
          console.error(error);
        }
      });
    }
    this.$store.dispatch('initApp', this.$ApiClient);
    this.$barcodeScanner.barCodeEventBus.$on('scanDelayed', this.notAllowedToScan);
    this.getOrderHandlingRoute();
    // De computed snapt niet dat de localstorage gewijzigd is
    // Dus er is een method gemaakt ipv computed
    // En die moet via een event opnieuw getriggerd worden
    // Anders wordt hij berekent vóórdat de waarde gewijzigd is.
    this.$globalEventBus.$on('orderhandling-view-changed', (params) => {
      this.getOrderHandlingRoute();
    });

    // Close the opened status when the app is hidden
    document.addEventListener("visibilitychange", () => {
      const loadingCargoId = store.getters.getLoadingCargoId;
      if (loadingCargoId) {
        const closed = document.hidden;
        if (closed) {
          // Disable opened
          closeCargo(true);
        } else {
          // Open again
          this.openCargo(loadingCargoId);
        }
      }

    });
  }
};
</script>

<style lang="scss">
@import "./assets/scss/main";
@import "./assets/scss/_customFramework";

</style>

